import { Dispatch, useCallback, useRef, useState } from "react";

// See: https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/useControlled/useControlled.js

interface UseControlledStateOptions<T> {
  uncontrolledValue?: T;
  controlledValue?: T;
}

type UseControlledStateResult<T> = [T | undefined, Dispatch<T | undefined>];

const useControlledState = <T,>(options?: UseControlledStateOptions<T>): UseControlledStateResult<T> => {
  const controlledValueRef = useRef(options?.controlledValue);

  const [uncontrolledValueState, setUncontrolledValueState] = useState(options?.uncontrolledValue);

  const value = controlledValueRef.current !== undefined ? options?.controlledValue : uncontrolledValueState;

  const setUncontrolledValueStateIfUncontrolled = useCallback((nextValue: T | undefined) => {
    if (controlledValueRef.current !== undefined) {
      return;
    }

    setUncontrolledValueState(nextValue);
  }, []);

  return [value, setUncontrolledValueStateIfUncontrolled];
};

export default useControlledState;
